module.exports = __webpack_public_path__ + "img/煤炭企业推进“自动化、信息化、智能化”融合发展的研究与实践—兖矿集团有限公司—1-1.979ea995.jpg";